import { createValidator } from 'revalidate';
const isRequired = createValidator(message => value => {
  if (value == null || typeof value === 'string' && value.trim() === '') {
    return message;
  }
  return null;
}, field => `${field} is required`);
export default isRequired;